import { getPublicRuntimeConfig } from '@watershed/config/utils/publicRuntimeConfig';

export default function getAppVersion(): string {
  return getPublicRuntimeConfig('NEXT_PUBLIC_CLIENT_VERSION') ?? 'unknown';
}
